/*========================================================================
* $Id: timeline.js 101190 2017-09-04 06:47:45Z daniel.eppensteiner $
*
* Copyright © Mindbreeze Software GmbH, Linz, Austria, 2005-2013
*
* Der Nutzer des Computerprogramms anerkennt, dass der oben stehende
* Copyright-Vermerk im Sinn des Welturheberrechtsabkommens an der vom
* Urheber festgelegten Stelle in der Funktion des Computerprogramms
* angebracht bleibt, um den Vorbehalt des Urheberrechtes genuegend zum
* Ausdruck zu bringen. Dieser Urheberrechtsvermerk darf weder vom Kunden,
* Nutzer und/oder von Dritten entfernt, veraendert oder disloziert werden.
* =========================================================================*/


define([
  "component!base", 
  "client/views/tree", 
  "client/template",
  "underscore"
  ], function (
    Base, 
    TreeView, 
    Template,
    _
  ) {

    var TreeViewTemplate = Template.extend({
      createView: function(options)  {
        options = _.extend(
          this.attributeModel.getCamelCase(),
          options,
          {
            childrenPath: "children",
            elementTemplate: this.node.children[0].template
          }
          );

        delete options.node;
        return Template.prototype.createView.apply(this, [options]);
      },

      getContentSchema: function() {
        return  {
          type: "template"
        };
      },

      hasContent: function () {
        return true;
      }
    });

    TreeViewTemplate.View = TreeView.extend({

      createEntryView: function (options) {
        var options = _.extend(this.options, options, {
          elementTemplate: this.options.elementTemplate,
          el: void(0) 
        });
        delete options.tagName;
        delete options.className;

        return TreeView.prototype.createEntryView.call(this, options);
      }

    });

    TreeViewTemplate.View.EntryView = TreeView.EntryView.extend({

      initialize: function () {
        var options = _.clone(this.options);
        delete options.tagName;
        delete options.className;

        this.childView = this.createChildView(options);
        if (this.childView) this.childView.render();
        Base.prototype.initialize.apply(this, arguments);
        if (this.childView && this.childView.el) {
          this.insertAt(this.childView.el, 0);
        }

        var templateTree = this.options.application.templateTree;
        var clonedNode = _.clone(this.options.elementTemplate.parentTemplate.node);
        clonedNode.children = [];
        var that = this;
        templateTree.collect(clonedNode, this.childView.el, function(node) {
          clonedNode.initializeChildren(that.options.application, that.options.parentModel,
            function() {
            });
        });

      },

      createChildView: function (options) {
        if (this.options.createEntryViewAction && 
          this.options.application[this.options.createEntryViewAction]) {
          return this.options.application[this.options.createEntryViewAction].call(this.options.application, this.options.application, this, options);            
        }

        options = _.clone(options);
        options.application = this.options.application;

        return this.options.elementTemplate.createView(options);
      }
    }); 

    return TreeViewTemplate;
  });
